import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Mail, ChevronRight } from "lucide-react";
import { api, mediaUrl } from "@/lib/api";

export default function EquipePage() {
  const [team, setTeam] = useState([]);
  useEffect(() => { api.get("/team").then((r) => setTeam(r.data)); }, []);
  return (
    <div className="space-y-8" data-testid="equipe-page">
      <nav className="text-xs text-zinc-500 flex items-center gap-1"><Link to="/a-propos" className="hover:text-red-600">À propos</Link><ChevronRight size={12} /><span>Équipe</span></nav>
      <div className="border-l-4 border-red-600 pl-4">
        <h1 className="font-heading text-4xl sm:text-5xl font-black">L'équipe</h1>
        <p className="text-zinc-600 mt-2">La rédaction de Chronique.cd</p>
      </div>
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {team.map((m, i) => (
          <div key={m.id} data-testid={`team-member-${i}`} className="news-card overflow-hidden fade-up" style={{ animationDelay: `${i * 60}ms` }}>
            <div className="aspect-square bg-zinc-200 overflow-hidden">{m.photo_url ? <img src={mediaUrl(m.photo_url)} alt={m.name} className="w-full h-full object-cover" /> : <div className="w-full h-full flex items-center justify-center font-heading text-6xl font-black text-zinc-400">{m.name[0]}</div>}</div>
            <div className="p-5">
              <span className="badge-cat">{m.role}</span>
              <h3 className="font-heading font-extrabold text-xl mt-2">{m.name}</h3>
              <p className="text-sm text-zinc-600 mt-2">{m.bio}</p>
              {m.email && <a href={`mailto:${m.email}`} className="inline-flex items-center gap-1.5 text-xs font-bold text-red-600 mt-3 hover:text-red-800"><Mail size={12} /> {m.email}</a>}
            </div>
          </div>
        ))}
      </div>
      {!team.length && <p className="text-zinc-500 text-center py-10 bg-white border">L'équipe sera bientôt présentée.</p>}
    </div>
  );
}
